import { createReducer } from '@ces/sourced-action';
import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { on } from '@ngrx/store';
import { AutoDraft, AutoDraftData, AutoDraftEntities } from './auto-draft.model';
import { flushAutoDraftState, removeAutoDraft, setAutoDraft, setAutoDrafts } from './auto-draft.actions';


// Adapter

const adapter: EntityAdapter<AutoDraft> = createEntityAdapter<AutoDraft>({ selectId: a => a.accountNumber });


// Initial state

const initialState = adapter.getInitialState({ loaded: false }) as AutoDraftEntities;


// Runtime state

const addRuntimeState = (autoDraftData: AutoDraftData): AutoDraft => ({
    ...autoDraftData
});


// Reducer

export const autoDraftReducer = createReducer<AutoDraftEntities>(
    initialState,

    on(setAutoDrafts, (s, { autoDraftsData }) => (
    {
        ...adapter.setAll(autoDraftsData.map(addRuntimeState), s),
        loaded: true,
    })),

    on(setAutoDraft, (s, { autoDraftData }) => adapter.upsertOne(addRuntimeState(autoDraftData), s)),
    on(removeAutoDraft, (s, { accountNumber }) => adapter.removeOne(accountNumber, s)),

    on(flushAutoDraftState, s => initialState),
);
